import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { IAssociated, IParentList } from "app/models/core/lab/associated";
import { IDemographics } from "app/models/core/lab/demographics";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-parent',
  templateUrl: './parent.component.html'
})

export class ParentComponent implements OnInit {

  list: IParentList[] = [];
  displayedColumns: string[] = ['labId', 'labName', 'stateNumber'];

  dataSource = new MatTableDataSource<IParentList>(this.list);

  currentParent = '';
  listFilter = '';
  editMode = 'list';
  search = '';
  parentId = '';
  parentCount = 0;
  parentDemog: IDemographics;
  parent: IParentList;
  parentSelected = '';
  selected = '';

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService,
    private router: Router,
    private datePipe: DatePipe) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.loadParent();
      this.editMode = 'list';
    }
  }

  loadParent() {
    if (this.labService.associated.parentList[0] != null) {
      this.parentCount = 1;
      this.currentParent = this.labService.associated.parentList[0].labName;
      this.parentId = this.labService.associated.parentList[0].labId.toString();
    }
    else {
      this.parentCount = 0;
      this.currentParent = '';
      this.parentId = null;
    }
  }

  getParentList() {
    if (this.search != null && this.search != '') {
      this.labService.getParentList(this.search).subscribe(
        res => {
          this.list = res;
        },
        error => console.log('error: ', error),
        () => {
          this.dataSource.data = this.list;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  editParent() {
    this.editMode = 'edit';

  }

  printLicense() {
    //TODO
  }

  addNewParent() {
    this.editMode = 'add';
  }


  deleteParent(): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }
    this.labService.deleteAssociated(this.labService.lab.labId, 'Parent').subscribe(
      () => {
        this.labService.associated.parentList[0] = null;
        this.labService.lab.parentId = null;
        this.loadParent();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );

  }

  saveParent() {
    let newParent: IAssociated;
    if (this.labService.associated.parentList[0] == null) {
      // create new IAssociated to send
      newParent = {
        labId: this.labService.lab.labId,
        labName: this.parent.labName,
        parentId: this.parent.labId,
        address: '',
        associatedLookupDict: null,
        associatedLookupDictResults: false,
        city: '',
        cliaNumber: '',
        comments: '',
        createdBy: '',
        dateCreated: '',
        director: '',
        edit: false,
        hstId: 0,
        hstLabId: 0,
        labType: '',
        lastUpdated: '',
        multipleId: 0,
        newAssociatedLabId: 0,
        parentFound: false,
        sharedId: 0,
        soaId: 0,
        state: '',
        stateNumber: '',
        taxId: '',
        updatedby: '',
        zip: ''
      };
      this.labService.associated.parentList = [newParent];
    }
    else {
      newParent = this.labService.associated.parentList[0];
      this.labService.associated.parentList[0].parentId = +this.parentSelected;
      this.labService.associated.parentList[0].labName = this.parent.labName;
    }

    this.labService.saveAssociatedLab(newParent, 'Parent').subscribe(
      () => {
        this.loadParent();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
        this.labService.lab.parentId = newParent.labId
      }
    );
  }

  cancel() {
    this.editMode = 'list';
    this.list = [];
    this.parentSelected = null
  }

  home() {
    sessionStorage.setItem('searchFilter', this.labService.associated.parentList[0].labName);
    sessionStorage.setItem('labStatus', '');
    sessionStorage.setItem('type', '');
    sessionStorage.setItem('cert', '');
    this.router.navigate(['home/']);
  }

  clearSearch() {
    this.search = "";
  }

  radioSelected(select: IParentList) {
    this.parent = select;
    this.parentSelected = select.labId.toString();
  }

}